<template>
  <div
    style="height: 100%; width: 100%;  backround-size:100% 100%;"
    class="note"
    :style="note"
  >
    <div class="conent">
      <div class="left">
        <div
          class="text"
          style="margin-top:122px; margin-left:64px; font-size:24px ;
font-weight:bold; "
        >登录桃花导购后台系统</div>
        <div class="text1">桃花汽车一站式导购</div>
        <img src alt />

        <div class="box01">
          <i class="icon"></i>

          <input class="inputx" placeholder="用户名" v-model="username" alt />
        </div>
        <div class="box01">
          <input class="inputx" id="cc" type="password" v-model="password" placeholder="密码" />
          <i class="icon1"></i>
        </div>
        <button v-on:click="btnClick()" class="botton bottond">登录</button>
      </div>
      <div class="hgit">
        <img
          style="height: 100%; width: 100%;  backround-size:100% 100%; padding:1px;"
          src="../../assets/2993x.png"
          alt
        />
        <div class="foot">
          <a target="_blank" href="https://beian.miit.gov.cn/">
            <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#000000;">粤ICP备20019010号</p>
          </a>
        </div>
        <div class="foot2">
		 		  <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44060402001916">
           <img src="../../assets/beiantubiao.png" style="float:left;"/>
           <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#000000;">粤公网安备 44060402001916号</p>
          </a>
		 	  </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
export default {
  data() {
    return {
      username: "",
      password: "",
      note: {
        backgroundImage: "url(" + require("../../assets/3003x.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        width: "100%",
        heihgt: "100%",
        overflow: "hidden"
      }
    };
  },
  computed: {},
  methods: {
    btnClick: function() {
      sessionStorage.setItem("islogin", false);
      if (null == this.username || "" == this.username) {
        this.$alert("用户名不能为空", "错误信息", {
          confirmButtonText: "确定",
          // callback: action => {
          //   this.$message({
          //     type: "info",
          //     message: `action: ${action}`
          //   });
          // }
        });
        return;
      }
      if (null == this.password || "" == this.password) {
        this.$alert("密码不能为空", "错误信息", {
          confirmButtonText: "确定",
          // callback: action => {
          //   this.$message({
          //     type: "info",
          //     message: `action: ${action}`
          //   });
          // }
        });
        return;
      }

      this.$http
        .post(
          "/api/system/sys/login?username=" +
            this.username +
            "&password=" +
            this.password,
          {"username":this.username,"password":this.password}
        )
        .then(resp => {
          let data = resp.data;
          if (data.code === "0") {
            sessionStorage.setItem("islogin", true);
            let userData = data.data;
            sessionStorage.setItem("name", userData.username);
            sessionStorage.setItem("role", userData.roleName);
            sessionStorage.setItem("accessToken", userData.token);
            sessionStorage.setItem("menuPermsList", userData.menuPermsList);
            let vaule = sessionStorage.getItem("accessToken");
            this.$router.push({ path: "/index" });
          } else {
            sessionStorage.setItem("islogin", false);
            this.$alert("" + data.message, "温馨提示", {
              confirmButtonText: "确定"
            });
          }
        })
        .catch(response => {
          this.$alert(
            "服务器发生异常，请联系开发者，这是错误信息：" + response,
            "错误提示",
            {
              confirmButtonText: "确定"
            }
          );
        });
    }
  },
  mounted() {
    new Swiper(".swiper-container", {
      loop: true, // 循环模式选项
      paginationClickable: true,
      // nextButton: '.swiper-button-next',
      // prevButton: '.swiper-button-prev',
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination"
      }
    });
  },
  created() {
    let that = this;
    document.onkeypress = function(e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13) {
        that.btnClick();// 登录方法名
         return false;
      }
    };
  }
};
</script>

<style scoped>
.icon {
  position: absolute;
  display: inline-blick;
  height: 16px;
  width: 16px;
  background-image: url(../../assets/user_name.png);
  background-repeat: no-repeat;
  position: absolute;
  top: 24%;
  left: 70px;
  margin-top: 32px;
  z-index: 2;
  padding-top: 5px;
}
.icon1 {
  position: absolute;
  display: inline-blick;
  height: 16px;
  width: 16px;
  background-image: url(../../assets/password.png);
  background-repeat: no-repeat;
  position: absolute;
  top: 24%;
  left: 70px;
  margin-top: 17px;
  z-index: 2;
  padding-top: 5px;
}
.bottond {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 17px;
  color: rgba(255, 255, 255, 1);
  opacity: 1;
}
.box01 {
  position: relative;
}
.conent {
  display: flex;
  width: 900px;
  height: 563px;
  overflow: hidden;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 23px 30px rgba(32, 45, 88, 0.16);
  opacity: 1;
  border-radius: 21px;
  margin: 10% auto;
}
#cc {
  margin-top: 21px;
}
text {
  width: 255px;
  height: 36px;
  margin-top: 122px;

  font-size: 26px;
  font-weight: bold;
  line-height: 36px;
  color: rgba(51, 51, 51, 1);
  opacity: 1;
}
.text1 {
  margin-left: 65px;
  width: 108px;
  height: 17px;
  font-size: 12px;
  font-weight: 500;
  line-height: 17px;
  color: rgba(153, 153, 153, 1);
  opacity: 1;
}
.inputx {
  margin-left: 61px;
  padding-left: 35px;
  margin-top: 42px;
  height: 218px;
  border: 0;
  outline: none;
  background-color: rgba(0, 0, 0, 0);
  color: #b2b2b2;
  width: 249px;
  height: 33px;
  background: rgba(247, 246, 249, 1);
  opacity: 1;
  border-radius: 17px;
}

.botton {
  color: #fff;
  margin: 0;
  padding: 0;
  border: 1px solid transparent;
  outline: none;
  width: 137px;
  height: 33px;
  background: linear-gradient(
    90deg,
    rgba(7, 137, 234, 1) 0%,
    rgba(32, 147, 248, 1) 100%
  );
  box-shadow: 0px 3px 5px rgba(7, 137, 234, 0.3);
  opacity: 1;
  border-radius: 17px;
  margin-top: 26px;
  margin-left: 62px;
}
.left {
  width: 352px;
  flex-direction: column;
}
.hgit {
  width: 100%;
  height: 100%;
  background-size: 100%;
}
.foot {
    position: absolute;
    bottom: 0;
    left: 70%;
    transform: translateX(-50%);
}
.foot2 {
  position: absolute;
    bottom: 0;
    left: 85%;
    transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/views/login/Login.vue